<template>
  <div style="display: inline;">
    <yi_curd_table :name="$options.name" ref="yt" getUrl="/web/basic/procedure/material/month/price/page" getKey="rows" :columns="columns" @selectionChange="selectionChange">
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.materialIds"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('yuefen')">
            <el-input v-model="yt.conditions.month"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button :loading="yt.loading" @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>

            <el-button :loading="yt.loading" @click="clear()">{{ $t('chongzhi') }}</el-button>
          </el-form-item>
        </el-form>
      </template>
      <template #buttonsL>
        <el-button size="mini" type="primary" @click="yt.showEditDialog('daoru', null, 'w2')">
          {{ $t('daoru') }}
        </el-button>
<!--        <el-button type="primary"  size="mini" @click="exportExcel()" v-if="utils.checkPower('web_base_process_procedure_material_month_price_export')">-->
<!--          {{ $t('daochu') }}-->
<!--        </el-button>-->
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" v-if="utils.checkPower('web_base_process_procedure_material_month_price_export')" icon="yicon yicon-export" :title="$t('daochu')" @click="exportExcel()"></el-button>
        <!--        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>-->
      </template>
    </yi_curd_table>

    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <template v-if="yt.editObj.action === 'daoru'">
        <div class="dialog-scroller">
          <yi_excel_import ref="materialMonthPriceImportTemplate" :templatekey="'material_month_price_import_template'" :uploadApi="'/web/basic/procedure/material/month/price/batchimport'" />
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="default" size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button type="primary" size="mini" :loading="mainSubImportLoading" @click="mainSubImportData">{{ $t('baocun') }}</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'material_price_mouth_price',
  data() {
    return {
      mainSubImportLoading: false,
      columns: [
        {
          label: 'chanpinbianma',
          prop: 'material.code'
        },
        {
          label: 'chanpinmingcheng',
          prop: 'material.name'
        },
        {
          label: 'guige',
          prop: 'material.spec'
        },
        {
          label: 'caizhi',
          prop: 'material.ingredient'
        },
        {
          label: 'yanse',
          prop: 'material.color'
        },
        {
          label: 'yuefen',
          prop: 'month'
        },
        {
          label: 'danjia',
          prop: 'price'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions.workProcedureId = this.$attrs.workProcedureId;
      this.yt.conditions.orderBy = 'month desc';
      this.yt.get(1);
    }, 300);
  },
  methods: {
    clear() {
      this.yt.conditions.materialIds = [];
      this.yt.conditions.workProcedureId = this.$attrs.workProcedureId;
      this.yt.conditions.month = "";
      this.yt.conditions.orderBy = 'month asc';
      this.yt.get(1);
    },

    mainSubImportData() {
      let data = [...this.$refs.materialMonthPriceImportTemplate.tableData];
      if (data.length <= 0) {
        this.$message.error(this.$t('qingshangchuanwenjian'));
        return;
      }
      if (this.$refs.materialMonthPriceImportTemplate.listLength == null || this.$refs.materialMonthPriceImportTemplate.listLength.length == 0) {
        this.mainSubImportLoading = true;
        return this.http
          .post('/web/basic/procedure/material/month/price/batchimport?onlyValidate=false&workProcedureId=' + this.yt.conditions.workProcedureId, data)
          .then(response => {
            this.utils.successMessage(this.$t(response.msg));
            this.yt.isShowEditDialog = false;
            this.yt.get(1);
          })
          .catch(err => {
            this.utils.errorMessage(this.$t(err));
          })
          .finally(() => {
            this.mainSubImportLoading = false;
          });
      } else {
        this.utils.errorMessage(this.$t('daoruxinxiyouwu'));
      }
    },

    exportExcel() {
      let params = this.yt.conditions;
      params.workProcedureId = this.$attrs.workProcedureId;

      return this.http
          .get('/web/report/export/procedure_material_month_price_export', { params })
          .then(res => {
            this.$message.success(this.$t(res.msg));
            this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');
          })
          .catch(error => {
            this.$message.error(this.$t(error));
          });
    }
  }
};
</script>
